import React from 'react';
import { css } from 'styled-components';
import styled from 'styled-components';
import { colors } from '../theme/ColorTheme';
import { FormattedHTMLMessage } from 'react-intl'; 

export default ({ setValue, value }) => (
    <RadioFlexContainer>
        <RadioWrapper onClick={() => setValue(true)}>
            <CustomRadioYes>{value == true ? <CustomRadioInner /> : null}</CustomRadioYes>
            <LabelText><FormattedHTMLMessage id="LabelJa" /></LabelText>
        </RadioWrapper>
        <RadioWrapper onClick={() => setValue(false)}>
            <CustomRadioNo value={value}>{value == false ? <CustomRadioInner /> : null}</CustomRadioNo>
            <LabelText><FormattedHTMLMessage id="LabelNein" /></LabelText>
        </RadioWrapper>
    </RadioFlexContainer>
);

const RadioFlexContainer = styled.div`
    display: flex;
    align-items: center;
    & ${RadioFlexContainer}:nth-child(2) {
        margin-left: 41px;
    }
`;

const LabelText = styled.span`
    margin-left: 12px !important;
`;

const CustomRadioInner = styled.div`
    width: 0.615rem;
    height: 0.615rem;
    position: absolute;
    background-color: ${colors.projectBlue};
    transform: translate(39%, 39%);
    border-radius: 50%;
    box-shadow: 0 0 10px 0 ${colors.radioBoxShadow};
    z-index: 2;
`;

const CustomRadio = styled.div`
    width: 1.25rem;
    height: 1.25rem;
    background-color: ${colors.white};
    border-radius: 50%;
    transition: all 150ms;
    position: relative;
    &::after {
        display: none;
    }
`;

const RadioWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
        ${CustomRadio}::after {
            display: block;
            content: '';
            width: 0.615rem;
            height: 0.615rem;
            position: absolute;
            background-color: ${colors.radioBackground};
            transform: translate(39%, 39%);
            border-radius: 50%;
            z-index: 1;
        }
        ${CustomRadio} {
            box-shadow: 0 0 10px 0 ${colors.radioBoxShadow};
        }
    }
`;

const CustomRadioYes = styled(CustomRadio)`
    ${props => (props.witchRadioActive ? checkedStyles : uncheckedStyles)};
`;

const CustomRadioNo = styled(CustomRadio)`
    ${props => (props.witchRadioActive == true ? uncheckedStyles : checkedStyles)};
`;

const checkedStyles = css`
    border: 1px solid ${colors.projectBlue};
    box-shadow: 0 0 10px 0 ${colors.radioBoxShadow};
`;
const uncheckedStyles = css`
    border: 1px solid ${colors.borderColor};
`;
